import { render, staticRenderFns } from "./BadRequest.vue?vue&type=template&id=51d2f97e&scoped=true"
import script from "./BadRequest.vue?vue&type=script&lang=ts"
export * from "./BadRequest.vue?vue&type=script&lang=ts"
import style0 from "./BadRequest.vue?vue&type=style&index=0&id=51d2f97e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d2f97e",
  null
  
)

export default component.exports